export const PRODUCT_ITEM_RESOURCE_PATH = '/v1/feichtinger/iteminformation/item/{{id}}';
export const PRODUCT_IDENT_RESOURCE_PATH = '/v1/feichtinger/iteminformation/ident/{{id}}';
export const PRODUCT_QR_RESOURCE_PATH = '/v1/feichtinger/iteminformation/qr/{{id}}';

export const VALIDATE_SCAN_RESOURCE_PATH = '/v1/items/scan/{{labelType}}/{{data}}';
export const SCAN_QUERY_RESOURCE_PATH = '/v1/bean/query/artstamm';
export const SCAN_RESULT_RESOURCE_PATH = '/v1/bean/abfrageResult/artstamm/{{id}}';
export const CHARGE_RESOURCE_PATH = '/v1/bean/query/charge';
